import { formatAssetAmount } from '@altify/utils';
import { Language } from 'store/slices/language-slice';
import appHelpers from '../utils/app-urls';
import { ActiveProductDtoTypeEnum } from 'services/generated';

// TODO :: Below and is CryptoCurrency checks need to be change when product.type is passed through for pending withdrawals
const tradableFiatCurrencies = [
  'R',
  'GB',
  'ZAR',
  'GBP',
  '£',
  'USD',
  '$',
  'EUR',
  '€',
];

export const isCryptoCurrency = (productCode: any) => {
  return !tradableFiatCurrencies.includes(productCode);
};
export const commodityProductCodes = ['PAXG'];

export const formatCurrency = (
  amount: number | undefined | null,
  code: string | undefined | null,
) => {
  return formatAssetAmount(amount ?? null, code ?? null, { showSpacer: true });
};

const messages = {
  en: {
    crypto: 'Crypto',
    stablecoin: 'Stablecoin',
    currency: 'Currency',
    reserved: 'Reserved',
    cryptoBundle: 'Crypto Bundle',
    commodity: 'Commodity',
    privateCredit: 'Private Credit',
    stocks: 'Stock',
    tokenizedStocks: 'Tokenised Stock',
  },
};

export const getCurrencyTypeLabel = (
  productCode: string,
  type: ActiveProductDtoTypeEnum,
  language?: Language,
) => {
  const commonMessages = messages[(language as Language) || 'en'];

  // TODO: enable when we have added the commodities tab in the app.
  if (['PAXG'].includes(productCode as string)) {
    return commonMessages.commodity;
  }

  switch (type) {
    case ActiveProductDtoTypeEnum.Fiat:
      return commonMessages.currency;
    case ActiveProductDtoTypeEnum.Crypto:
      if (productCode?.toLowerCase().includes('rvx')) {
        return commonMessages.cryptoBundle;
      }
      return commonMessages.crypto;
    case ActiveProductDtoTypeEnum.Bundle:
      return commonMessages.cryptoBundle;
    case ActiveProductDtoTypeEnum.Stablecoin:
      return commonMessages.stablecoin;
    case ActiveProductDtoTypeEnum.Locked:
      return commonMessages.reserved;
    case ActiveProductDtoTypeEnum.PrivateCredit:
      return commonMessages.privateCredit;
    case ActiveProductDtoTypeEnum.Stock:
      return commonMessages.tokenizedStocks;
    default:
      return type;
  }
};
